import ResponseStatus from '../constants/ResponseStatus';
import { fetchStudiesData } from '../veevaIdApi';
import { showErrorNotificationFromResponse } from './errorUtils';
import sortStudiesData from './sortStudiesData';

/**
 * @typedef Study
 * @param {string} studyName
 * @param {string} redirectUrl
 */

/**
 * @typedef StudiesResponse
 * @prop {string} companyName
 * @prop {string} redirectUrl
 * @prop {string} [lastLogin] ISO datetime
 * @prop {string} lastLoginFormatted human-readable date, formatted by locale
 * @prop {Study[]} studies
 */

/**
 * Wrapper that fetches system data and modifies the result
 * @param {string} language
 * @returns {StudiesResponse[]}
 */
const getStudiesData = async (language) => {
    const response = await fetchStudiesData();
    if (response.responseStatus !== ResponseStatus.SUCCESS) {
        const i18nOptions = { language };
        showErrorNotificationFromResponse(response, i18nOptions);
        return [];
    }

    if (!response?.data) {
        return undefined;
    }

    const studiesWithFormattedLastLogin = response.data.map((studyData) => ({
        ...studyData,
        lastLogin: studyData.lastLogin && new Date(studyData.lastLogin),
    }));

    // sort with the most recent logins first
    const sortedStudies = sortStudiesData(studiesWithFormattedLastLogin);

    return sortedStudies;
};

export default getStudiesData;
